import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getStorage, ref, listAll, getDownloadURL } from "firebase/storage";
import "./Activities.css";
import Navbar from '../../components/navigationbar/Navbar';
import Footer from "../../components/Footer/Footer";
import bg2 from '../../assets/bg-images/bg2.jpg'

const Activities = () => {
  const { year } = useParams(); // Get year from URL
  const [activities, setActivities] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const storage = getStorage();

  useEffect(() => {
    const fetchFoldersAndImages = async () => {
      if (!year) return;
      setIsLoading(true);
      const storageRef = ref(storage, `ActivityPageData/${year}`);
      const folderList = await listAll(storageRef);
      
      const activityData = [];
      
      for (const folder of folderList.prefixes) {
        const folderName = folder.name;
        const folderRef = ref(storage, `ActivityPageData/${year}/${folderName}`);
        const result = await listAll(folderRef);
        
        const imageUrls = await Promise.all(
          result.items.map((itemRef) => getDownloadURL(itemRef))
        );
        
        activityData.push({ title: folderName, images: imageUrls });
      }
      
      setActivities(activityData);
      setIsLoading(false);
    };
    
    fetchFoldersAndImages();
  }, [storage, year]);

  const openLightbox = (image) => {
    setCurrentImage(image);
    setIsOpen(true);
  };

  const closeLightbox = () => {
    setIsOpen(false);
    setCurrentImage(null);
  };

  return (
    <>
      <Navbar />
      <div className="activities">
        <div className="carousel">
          <div className="carousel-slider">
            <img className='bg-image' src={bg2} alt="Committee" />
          </div>
          <div className="carousel-caption">
            <h1>ACTIVITY</h1>
            <h5>{year}</h5>
          </div>
        </div>

        {isLoading ? (
          <div className="skeleton-section" style={{marginTop:"50px"}}>
            {[1, 2, 3, 4,5,6,7,8].map((_, index) => (
              <div key={index} className="skeleton-title">
                <div className="skeleton-title-bar" style={{width:"300px"}}></div>
                <div className="skeleton-gallery">
                  {[1, 2, 3, 4,5,6,7,8].map((_, idx) => (
                    <div key={idx} className="skeleton-image"></div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : (
          activities.map((activity, index) => (
            <div key={index} className="activity-section">
              <h2>{activity.title}:</h2>
              <div className="activity-gallery">
                {activity.images.map((image, idx) => (
                  <figure
                    key={idx}
                    onClick={() => openLightbox(image)}
                    className="activity-image"
                  > 
                    <img src={image} alt={`Activity ${activity.title} Image ${idx + 1}`} className="activity-img" />
                  </figure>
                ))}
              </div>
            </div>
          ))
        )}

        {isOpen && (
          <div className="lightbox" onClick={closeLightbox}>
            <div className="lightbox-content">
              <span className="lightbox-close" onClick={closeLightbox}>
                &times;
              </span>
              <img
                src={currentImage}
                alt="Expanded Activity"
                className="lightbox-image"
              />
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Activities;
